// import * as d3 from 'd3'

// export const seriesColors = d3.schemeTableau10
export const seriesColors = [
  '#1976d2',
  '#009688',
  '#4CAF50',
  '#F44336',
  '#607D8B',
  '#FFEB3B',
  '#673AB7',
  // '#173753',
  // '#4CB944',
  // '#744FC6',
  // '#BAFF29',
]